import script from "./EditTask.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTask.vue?vue&type=script&setup=true&lang=js"

import "./EditTask.vue?vue&type=style&index=0&id=5b0d44ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b0d44ce"]])

export default __exports__